angular.module("avant.customer_applications.directives").directive "amountLoanAmountSelectorDropdown", [
  "$filter", "$q", "ApplicationService", "ProductService", ($filter, $q, ApplicationService, ProductService) ->
    restrict: "E"
    scope:
      attrName: "@"
      inputUsedForUpdate: "="
      labelContent: "@"
      neuroSelectQuestion: "@"
      objectName: "@"
      optionsSize: "@displayOptionsSize"
      product: "="
      requestedLoanAmountError: "="
      serverErrors: "="
      submittingPage: "="
    template: """
      <div class="form__stack">
        <div class="form__row">
          <div class="form__group">
            <label class="sr-only" for="{{ fieldNameUnderscore }}">
              {{ labelContent }}
            </label>
            <select
              required=""
              aria-describedby="{{ fieldNameUnderscore }}_client_error serverError"
              class="form__select"
              id="{{ fieldNameUnderscore }}"
              ng-change="update()"
              ng-model="loanAmount"
              ng-class="{ 'form__alert': serverErrors || requestedLoanAmountError }"
            >
              <option
                value="{{ loanAmount }}"
                ng_repeat="loanAmount in product.requestable_loan_amounts"
                ng_selected="{{ product.requested_amount == loanAmount }}"
              >
                {{ formatPretty(loanAmount) }}
              </option>
            </select>
            <small
              id="{{ fieldNameUnderscore }}_client_error"
              aria-live="polite"
              class="form__error"
              ng-show="requestedLoanAmountError"
              role="alert"
            >
              Invalid amount selected
            </small>
            <small
              id="serverError"
              aria-live="polite"
              class="form__error"
              ng-show="serverErrors"
              ng-repeat="serverError in serverErrors"
              role="alert"
            >
              {{ serverError }}
            </small>
          </div>
        </div>
      </div>
    """
    link: (scope, element, attrs) ->
      scope.fieldNameUnderscore = "#{scope.objectName}_#{scope.attrName}"
      scope.inputUsedForUpdate = "##{scope.fieldNameUnderscore}"

      if scope.optionsSize
        selectInputElement = element.find('select')[0]

        styleForDesktop = ->
          selectInputElement.setAttribute('size', scope.optionsSize)
          # for min-height we are using 20px for each optionSize and an additional 10 px to illustrate to the user
          # that there are additional options that can be viewed by scrolling
          selectInputElement.setAttribute('style', "min-height: #{(scope.optionsSize * 20) + 10}px; background-image: none;")
        styleForMobile = ->
          selectInputElement.setAttribute('size', 1)
          selectInputElement.setAttribute('style', "min-height: 20px")

        adjustStyle = (mediaQuery) ->
          if mediaQuery.matches then styleForDesktop() else styleForMobile()

        mediaQuery = window.matchMedia("(min-width: 37.5em)")
        mediaQuery.addListener(adjustStyle)

        adjustStyle(mediaQuery)

      # neuro attributes need to be conditionally added to the element, otherwise if NeuroID is unused
      # and the attribute is undefined NeuroID throws an error
      if !!attrs.neuroSelectQuestion then element.attr('neuro-select-question', attrs.neuroSelectQuestion)

      scope.formatPretty = (value) ->
        "$#{$filter('number')(value, 0)}"

      validateInput = ->
        if parseInt(scope.loanAmount) in scope.product.requestable_loan_amounts
          scope.requestedLoanAmountError = false
        else
          scope.requestedLoanAmountError = true

      scope.update = ->
        validateInput()
        !scope.requestedLoanAmountError && debouncedUpdateProductAmount()

      debouncedUpdateProductAmount = _.debounce(
        () -> updateProductAmount(),
        800
      )

      updateProductAmount = ->
        appId = ApplicationService.target_application_id()
        return unless appId
        scope.product.loans = []
        deferred = $q.defer()
        unless scope.submittingPage
          clearSelectedLoan()
          ProductService.update(appId, { borrow_amount: scope.loanAmount }).then ->
            if scope.product.requested_amount != parseInt(scope.loanAmount)
              validateInput()
              unless scope.requestedLoanAmountError
                updateProductAmount(parseInt(scope.loanAmount))
              return deferred.resolve()
            scope.loanAmount = ProductService.getBorrowAmount().toString()
            deferred.resolve()
        deferred.promise

      clearSelectedLoan = ->
        scope.product.selected_loan = null

      scope.loanAmount = ProductService.getBorrowAmount().toString()
  ]
